<template>
  <el-dialog title="编辑设备"
             :visible.sync="showModal"
             @close="handleCancel"
             width="40%">
    <el-col :span="24">
      <el-form :model="modalInfo"
               :rules="modalRules"
               ref="modalForm"
               label-width="100px"
               class="modal-form">
        <el-form-item label="设备名称:"
                      prop="name">
          <el-input v-model.trim="modalInfo.name"
                    placeholder="请输入设备名称"></el-input>
        </el-form-item>
        <el-form-item label="通道号:"
                      prop="gate_channel">
          <el-input v-model.number.trim="modalInfo.gate_channel"
                    placeholder="请输入通道号"></el-input>
        </el-form-item>
        <el-form-item label="联机模式:"
                      prop="ol_mode">
          <el-switch v-model="modalInfo.ol_mode"
                     active-color="#13ce66"
                     inactive-color="#ff4949"
                     active-value="1"
                     inactive-value="0">
          </el-switch>
        </el-form-item>
        <el-form-item label="设备类型:"
                      prop="lock_model">
          <el-input v-model.trim="modalInfo.lock_model"
                    placeholder="请输入设备类型"></el-input>
        </el-form-item>
        <el-form-item label="介质类型:"
                      prop="lock_med">
          <el-checkbox-group v-model="modalInfo.lock_med">
            <el-checkbox v-for="item in medList"
                         :key="item.value"
                         :label="item.code">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="所属楼宇:"
                      prop="area_id">
          <el-select v-model="modalInfo.area_id"
                     placeholder="请选择所属楼宇"
                     @change="areaChange">
            <el-option v-for="item in areaList"
                       :disabled="item.area_type !== 'area_type_yes'"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属房间:"
                      prop="room_id">
          <el-select v-model="modalInfo.room_id"
                     placeholder="请选择所属房间">
            <el-option v-for="item in roomList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注:"
                      prop="remarks">
          <el-input type="textarea"
                    v-model.trim="modalInfo.remarks"
                    placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
    </el-col>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button v-has="'/lock/edit'"
                 type="primary"
                 @click="handleConfirm('modalForm')">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      showModal: this.isShow,
      modalInfo: {
        name: '',
        gate_channel: '',
        ol_mode: '',
        area_id: '',
        room_id: '',
        lock_model: '',
        lock_med: [],
        remarks: ''
      },
      modalRules: {
        name: [{ required: true, message: '请输入设备名称' }],
        gate_channel: [
          { required: true, message: '请输入通道号' },
          { type: 'number', message: '必须为数字值' }
        ],
        ol_mode: [{ required: true, message: '请选择联机模式' }],
        area_id: [{ required: true, message: '请选择所属楼宇' }],
        room_id: [{ required: true, message: '请选择所属房间' }],
        lock_model: [{ required: true, message: '请输入设备类型' }],
        lock_med: [{ required: true, message: '请选择介质类型' }]
      },
      areaList: [],
      roomList: [],
      medList: [],
      tmpArr: []
    }
  },
  created() {
    this.getList()
    this.getInfo()
    this.getItemList()
  },
  methods: {
    // 获取编辑信息
    getInfo() {
      fetch.getLockInfo({ id: this.data.id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.modalInfo = {
              id: data.info.id,
              name: data.info.name,
              gate_channel: Number(data.info.gate_channel),
              ol_mode: data.info.ol_mode,
              area_id: data.info.area_id,
              room_id: data.info.room_id,
              lock_model: data.info.lock_model,
              remarks: data.info.remarks
            }
            let tmpLock = data.info.lock_med ? data.info.lock_med.split(',') : []
            this.$set(this.modalInfo, 'lock_med', tmpLock)
            this.getRoom(data.info.area_id)
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取数据
    getList() {
      fetch.getAreaTree({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.areaList = this.titleFormat(data.treeData, '• ')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取介质类型
    getItemList() {
      fetch.getItemList({ type_code: 'open_med' }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.medList = data.list
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 切换楼宇时获取房间
    areaChange(val) {
      this.modalInfo.room_id = ''
      this.getRoom(val)
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let datas = JSON.parse(JSON.stringify(this.modalInfo))
          datas.lock_med = datas.lock_med.join(',')
          fetch.editLock({ ...datas }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.$message.success('操作成功')
                this.handleCancel('refresh')
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        } else {
          return false
        }
      })
    },
    handleCancel(type) {
      this.$emit('handleClose', type)
    },
    // 获取房间
    getRoom(id) {
      fetch.getRoomList({ area_id: id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.roomList = data.list
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    //  格式化名称
    titleFormat(data, prefix) {
      if (data.length === 0) {
        return []
      }
      data.forEach((item) => {
        let tmp = item
        tmp.name = prefix + item.name
        this.tmpArr.push(tmp)
        if (item.children && item.children.length > 0) {
          this.titleFormat(item.children, '• ' + prefix)
        }
      })
      return this.tmpArr
    }
  }
}
</script>

<style></style>
